 import React, { Component } from 'react';
import {Col, Row, Form, Button, Card, Modal} from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import classes from './interviewTiming.module.css';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import calendar from '../../Assets/icons/1x/datemdpi.png' 
import clock from '../../Assets/icons/1x/timemdpi.png'
import moment, { weekdays } from 'moment';
import * as actionTypes from '../../Action/Index';
import Loader from 'react-loader-advanced';
import Spinner from 'react-bootstrap/Spinner';
import SweetAlert from 'react-bootstrap-sweetalert';
import Preview from './previewTemplate'
import loading from '../../Assets/Images/loader-green.gif';

class interviewTiming extends Component {
    constructor(props) {
        super(props);
        this.state = {
          startDate: null,
          startTime: null,
          endTime: null,
          minTime : moment().hours(moment(this.props.availability.split(",")[1].split("-")[0] , ["h:mm A"]).format('HH')).minutes(moment(this.props.availability.split(",")[1].split("-")[0] , ["h:mm A"]).format('mm')).toDate(),
          maxTime: moment().hours ( moment(this.props.availability.split(",")[1].split("-")[1] , ["h:mm A"]).format('HH')).minutes(moment(this.props.availability.split(",")[1].split("-")[1] , ["h:mm A"]).format('mm')).toDate(),
          startMinTime: moment().hours(moment(this.props.availability.split(",")[1].split("-")[0] , ["h:mm A"]).format('HH')).minutes(moment(this.props.availability.split(",")[1].split("-")[0] , ["h:mm A"]).format('mm')).second('00').toDate(),
          endMaxTime:moment().hours(moment(this.props.availability.split(",")[1].split("-")[1] , ["h:mm A"]).format('HH')).minutes(moment(this.props.availability.split(",")[1].split("-")[1] , ["h:mm A"]).format('mm')).second('00').toDate(),
          previewShow:false,
          interviewerNote:"",
          candidateNote:"",
          interviewerTimings:null,
          candidateTimings:null,
          inviteButton:false,
          errorMsg:null,
          scheduleInterviewCount:0
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeTime = this.handleChangeTime.bind(this);
        this.handleChangeEndTime = this.handleChangeEndTime.bind(this);
      }
     
      handleChange(date) {
         
        this.setState({
          startDate: date
        });
       let data={
        "interviewerId":this.props.interviewerProfileValue.id,
        "candidateId":this.props.candidateId,
        "date": moment(date).format("ll"),
        
          }
        this.props.getInterviewerAvailableSlot(data);
      }


      handleChangeTime(time) {
          let dt = new Date(time);
          if(time.toString() ==  this.state.endMaxTime.toString())
          {
            this.setState({
                startTime: time,
                minTime: dt.setMinutes( dt.getMinutes()),
            });
          }
          else
          {
            this.setState({
                startTime: time,
                minTime: dt.setMinutes( dt.getMinutes() + 15 ),
            });
          }
      }
      handleChangeEndTime(time) {
        let dt = new Date(time);
        if(time.toString() ==  this.state.startMinTime.toString())
        {
            this.setState({
                endTime: time,
                maxTime : time,
               });
        }
        else{
            this.setState({
                endTime: time,
                maxTime : dt.setMinutes( dt.getMinutes() - 15 ),
               });
        }
      }
      previewModalShow=()=>{
       
          this.setState({
            previewShow:!this.state.previewShow,
            inviteButton:false
        })
        this.props.scheduleInterviewResetState()
      }

inputMethod=(event)=>{
    let nm=event.target.name;
    let valu=event.target.value;
    this.setState({[nm]:valu})
  }

handleSubmit = event => {
    event.preventDefault();
    event.stopPropagation();
    const bodyFormData = {
        "candidateId": this.props.candidatePageValue.id,
        "candidateNotes": this.state.candidateNote,
        "endTime":  moment(this.state.endTime).format('hh:mm A'),
        "interviewDate": moment(this.state.startDate).format('DD-MMM-YYYY'),
        "interviewerId": this.props.interviewerProfileValue.id,
        "interviewerNotes": this.state.interviewerNote,
        "jobProfileId": this.props.selectedJobProfile.id,
        "startTime": moment(this.state.startTime).format('hh:mm A'),
        "modeofinterview":this.props.selecttypeofInterviewValue
      }
       this.props.scheduleInterview(bodyFormData);
}

checkInterviewTime=()=>{

      if(this.state.startDate===null)
          {
            this.dateSelect.setFocus()
          }
          else if(this.state.startTime===null)
          {
            this.timeSelect.setFocus()
          }
          else if(this.state.endTime===null)
          {
            this.etimeSelect.setFocus()
          }
          else
          {
            const bodyFormData = { 
                "candidateId": this.props.candidatePageValue.id,
                "endTime":  moment(this.state.endTime).format('HH:mm:ss'),
                "date": moment(this.state.startDate).format('ll'),
                "interviewerId": this.props.interviewerProfileValue.id,
                "startTime": moment(this.state.startTime).format('HH:mm:ss'),
                "availableSlot":this.props.availability.split(",")[0], 
              }
             
               this.props.checkinterviewtime(bodyFormData);
          }

      
}

    isWeekday = (date) => {
        if(this.props.availability.split(",")[0].toUpperCase()=="WEEKDAY"){
          
            const day = date.getDay()     
            
                return day !== 0 && day !== 6;
        }
        if(this.props.availability.split(",")[0].toUpperCase()=="WEEKEND"){
          
            const day = date.getDay()     
            
                return day !== 1 && day !== 5 && day !== 2 && day !== 3 && day !== 4;
        }
        if(this.props.availability.split(",")[0].toUpperCase()=="SUNDAY"){
          
            const day = date.getDay()     
            
                return day == 0;
        }
        if(this.props.availability.split(",")[0].toUpperCase()=="SATURDAY"){
          
            const day = date.getDay()     
            
                return day == 6;
        }
      
      }

      componentWillReceiveProps=(nextProps)=>{
        if(nextProps.sufficientBalance != true)
        {
            this.props.history.push('/interview')
        }
          if(nextProps.interviewerInterviewByDate !== this.state.interviewerTimings || nextProps.candidateInterviewByDate!=this.state.candidateTimings)
          {
              this.setState({
                interviewerTimings:nextProps.interviewerInterviewByDate,
                candidateTimings:nextProps.candidateInterviewByDate
              })
          }
          if(nextProps.scheduleInterviewErrorMsg!==null)
          {
              this.setState({
                  errorMsg:nextProps.scheduleInterviewErrorMsg,
                  scheduleInterviewCount:1
              })
          }
          if(nextProps.getInterviewSlotErrorMsg!=null)
          {
              this.setState({
                  errorMsg:nextProps.getInterviewSlotErrorMsg
              })
          }

          if(nextProps.checkinterviewtimeMessage!=null)
          {
              this.setState({
                  errorMsg:nextProps.checkinterviewtimeMessage
              })
          }
          if(nextProps.checkinterviewtimeStatus==true)
          {
              this.setState({
                  previewShow:nextProps.checkinterviewtimeStatus
              })
          }
      }

      componentWillUnmount=()=>{
          this.setState({
            interviewTimings:[],
            errorMsg:null
          })
      }

      closeModal=()=>{
        this.setState({
            errorMsg:null,
            startDate:null,
            startTime:null,
            endTime:null
        },()=>{
            if(this.state.scheduleInterviewCount==1){
                this.props.history.push('/interview');
            }
        })
       

      }

        render() {
            
            return (
                <>
                 <Loader show={this.props.scheduleInterviewLoader || this.props.checkinterviewtimeLoader} message={ <img src = {loading}/> }
            foregroundStyle={{color: '#00a99d'}}
            backgroundStyle={{backgroundColor: '#F3EFEF'}}
            >
                <Form method="Post">
                    <Row>
                        <Col md={12}>
                            <div className={classes.heading}>
                            <h3>Schedule Interview</h3>
                            </div>
                           
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                        <Col md={9}>
                        <ul className="progress-tracker progress-tracker--text progress-tracker--text-inline progress-tracker--spaced">
        
        <li className="progress-step is-complete">
        
        <div className="progress-marker" data-text="1">
            <div className="progress-text">
            <h6 className="progress-title color">Job Profile</h6>
            </div>
        </div>
        </li>

        <li className="progress-step is-complete">
        <div className="progress-marker" data-text="2">
            <div className="progress-text">
            <h6 className="progress-title color">Candidate Profile</h6>
            </div>
        </div>
        </li>

        <li className="progress-step is-complete" aria-current="step">
        <div className="progress-marker" data-text="3">
            <div className="progress-text">
            <h6 className="progress-title color">Interviewer</h6>
            </div>
        </div>
        </li>

        <li className="progress-step is-active">
        <div className="progress-marker" data-text="4">
            <div className="progress-text">
            <h6 className="progress-title color">Interview Details</h6>
            </div>
        </div>
        </li>

    </ul>    
                     
                        </Col>
                    </Row>
                    <Row className={classes.gapTop}>
                      <Col md={12}>
                      <fieldset className={classes.schedulerBorder}>  
                      <legend className={classes.schedulerBorder}>Interview</legend>
                      {/* <span className={classes.interview} >Interview</span> */}
                    <Form.Group as={Row} controlId="formPlaintextEmail">
                     
                    <Col sm="6">
                        <Form.Label column className={classes.forLabel}>Date:</Form.Label>
                        
                        <div className={classes.inputContainer}>
                        <DatePicker
                            selected={this.state.startDate}
                            onChange={this.handleChange}
                            filterDate={this.isWeekday}
                            minDate={new Date()}
                            ref={(interviewDate) => this.dateSelect = interviewDate}
                            className={`form-control ${classes.inputText} rounded-0`}
                            dateFormat="dd MMM yy"
                            // placeholderText=""
                            // required
                            onKeyDown={e => e.preventDefault()} 
                            // name="interviewDate"
                        />
                         <img type="image/svg+xml" src={calendar}  alt="calender" onClick={() => this.dateSelect.setFocus()} className={`${classes.icon}`}/>
                        </div>
                        </Col>
                        <Col sm="6">
                        <Form.Label column className={classes.forLabel} sm="2">Start Time:</Form.Label>
                        <div className={`${classes.inputContainer} customDatePickerWidth`}>
                        <DatePicker
                            selected={this.state.startTime}
                            className={`form-control ${classes.inputText} rounded-0`}
                            onChange={this.handleChangeTime}
                            ref={(intervieTime) => this.timeSelect = intervieTime}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            minTime={this.state.startMinTime}
                            maxTime={this.state.maxTime}
                            dateFormat="h:mm aa"
                            timeCaption="Time"
                            required
                            onKeyDown={e => e.preventDefault()} 
                            name="startTime"

                           // excludeTimes={arr}

                        />
                         <img type="image/svg+xml" src={clock} onClick={() => this.timeSelect.setFocus()} alt="search" className={`${classes.icon}`} />
                        </div>
                        
                        <Form.Label column className={classes.forLabel} sm="2">End Time:</Form.Label>
                        <div className={`${classes.inputContainer} customDatePickerWidth`}>
                        <DatePicker
                            selected={this.state.endTime}
                            className={`form-control ${classes.inputText} rounded-0`}
                            onChange={this.handleChangeEndTime}
                            showTimeSelect
                            ref={(interviewendTime) => this.etimeSelect = interviewendTime}
                            minTime={this.state.minTime}
                            maxTime={this.state.endMaxTime}
                            showTimeSelectOnly
                            timeIntervals={15}
                            dateFormat="h:mm aa"
                            timeCaption="Time"
                            required
                            onKeyDown={e => e.preventDefault()} 
                            name="endTime"
                        />
                         <img type="image/svg+xml" src={clock} onClick={() => this.etimeSelect.setFocus()} alt="search" className={`${classes.icon}`} />
                        </div>
                        </Col>
                       
                    </Form.Group>
                    </fieldset>

                    <br/>
                   
                    </Col>
                    </Row>
                    

                   

                        <Modal size="lg" centered show={this.state.previewShow} >
                            
                            <Modal.Body>
                                <Preview
                                 candidateId={this.props.candidatePageValue}
                                 candidateNotes={this.state.candidateNote}
                                 endTime={moment(this.state.endTime).format('h:mm A')}
                                 interviewDate={moment(this.state.startDate).format('DD-MMM-YYYY').split('-')[0]+" "+moment(this.state.startDate).format('DD-MMM-YYYY').split('-')[1]+" ("+moment(this.state.startDate).format('llll').split(',')[0]+")"}
                                 interviewerId={this.props.interviewerProfileValue}
                                 interviewerNotes={this.state.interviewerNote}
                                 jobProfileId={this.props.selectedJobProfile}
                                 startTime={moment(this.state.startTime).format('h:mm A')}
                                 availability={this.props.availability}
                                selecttypeofInterviewValue={this.props.selecttypeofInterviewValue}
                                companyName={ this.props.companyName}
                                />
                            </Modal.Body>
                            <Modal.Footer>
                               
                                    <Button variant="outline-warning" className={classes.cancelBtn} onClick={this.previewModalShow}>
                                        Close
                                    </Button>
                                    <Form onSubmit={(e) => this.handleSubmit(e)}>
                                   
                                    <Button type="submit" className={classes.ModalnextBtn} 
                                    disabled={this.state.inviteButton}
                                    onClick={()=>{this.setState({inviteButton:true});this.previewModalShow()}} variant="warning">
                                       Send Invite
                                    </Button>
                                    </Form>

                            </Modal.Footer>
                        </Modal>
                        </Form>
                        </Loader>
                </>
            );
    }
}

const mapStateToProps = state => {
   
    return {
        scheduleInterviewEStatus: state.employeeReducer.scheduleInterviewEStatus,
        scheduleInterviewErrorMsg: state.employeeReducer.scheduleInterviewErrorMsg,
        scheduleInterviewLoader: state.employeeReducer.scheduleInterviewLoader,
        
        getInterviewSlotLoader : state.employeeReducer.availableSlotLoader,

        interviewerInterviewByDate :state.employeeReducer.interviewerInterviewByDate,
        candidateInterviewByDate:state.employeeReducer.candidateInterviewByDate,
        candidateName:state.employeeReducer.candidateName,
        interviewerName:state.employeeReducer.interviewerName,
        
        getInterviewSlotError : state.employeeReducer.availableSlotError,
        getInterviewSlotErrorMsg : state.employeeReducer.availableSlotErrorMsg,
        availableSlotNetworkError : state.employeeReducer.availableSlotNetworkError,


        sufficientBalance: state.employeeReducer.sufficientBalance,
        companyName:state.employeeReducer.companyName,

        checkinterviewtimeLoader:state.employeeReducer.checkinterviewtimeLoader,
        checkinterviewtimeStatus:state.employeeReducer.checkinterviewtimeStatus,
        checkinterviewtimeMessage:state.employeeReducer.checkinterviewtimeMessage,
        checkinterviewtimeLoaderExp:state.employeeReducer.checkinterviewtimeLoaderExp
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        scheduleInterview: (formData) => dispatch(actionTypes.scheduleInterview(formData)),
       
        getInterviewerAvailableSlot: (data) => dispatch(actionTypes.getInterviewerAvailableSlot(data)),
       
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(interviewTiming));